import * as constants from './constants';
import {
  fromJS
} from 'immutable';
const defaultState =  fromJS({
    subject: [],
    courseid:'',
    title:'',
    finishedList: []
})

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.CHANGE_LABROOM_DATA:
            return state.merge({
                subject:action.subject,
                courseid:action.courseid,
                title:action.title,
            });
        case constants.CHANGE_LABROOM_FINISHEDLIST:
            return state.merge({
                finishedList: action.finishedList
            })

        default:
            return state;
    }
}
